import {ItemAttribute, ItemAttrVals, PriceBundle} from '@app/core/models';
import GoponRes from '../gopon-res.model';

export class AddToCartReq {
  branchId!: number;
  itemId!: number;
  quantity!: number;
  cartId!: number;
  attributes?: ItemAttrVals[];
}

export interface Cart {
  CartId: number;
  UserId: number;
  CouponId: number;
  CouponApplied: boolean;
  CouponCode: string;
  SubTotal: number;
  SubTotalTitle: string;
  Discount: number;
  DiscountTitle: string;
  TotalAmount: 12;
  TotalAmountTitle: string;
  DeliveryCharge: number;
  DeliveryChargeTitle: string;
  PaymentMethod: number;
  Notes: string;
  AddressRequired: boolean;
  UserCartBranches: UserCartBranch[];
  UsersCartsAddresses: string;
  CartPaymentMethodList: CartPaymentMethod[];
  BranchId: number;
}

export interface UserCartBranch {
  UsersCartsItems: UsersCartsItem[];
  BranchName: string;
  BranchId: number;
  CompanyId: number;
  SupplierCode: string;
  BranchSubTotal: number;
  BranchDiscount: number;
  DeliveryCharge: number;
  DeliveryChargeTitle: string;
  BranchTotalAmount: number;
  Percentage: number;
}

export interface UsersCartsItem {
  ItemId: number;
  ItemName: string;
  ItemImage: string;
  ItemPriceTitle: string;
  ItemPrice: number;
  OldPriceTitle: string;
  OldPrice: number;
  Quantity: number;
  Type: number;
  ServiceCouponCode: string;
  itemAttributesValuesTitle: string;
  IsInStock: boolean;
  IsInStockTitle: string;
  SelectedItemAttributes: ItemAttribute[];
  PriceBundle: PriceBundle | null;
}

export interface CartPaymentMethod {
  Id: number;
  Name: string;
}

export interface CartRes extends GoponRes {
  UserCart: Cart;
}

export class CheckOutReq {
  userAddress?: {
    id: number;
  };
  orderWithUserProfile: boolean = false;
  OrderNotes?: string;
  cartId!: number;
  paymentMethod!: number;
  CallbackURL!: string;
}

export interface CheckOutRes extends GoponRes {
  PaymentURL: string;
  OrderId: number;
}
export interface OrderRes extends GoponRes {
  Orders: Order[];
}
export interface OrderDetailsRes extends GoponRes {
  Order: Order;
}
export interface Order {

  Id: number;
  OrderIdLabel: string;
  OrderIdTitle: string;
  OrderDateLabel: string;
  OrderDateTitle: string;
  OrderPaymentMethodLabel: string;
  OrderPaymentMethodTitle: string;
  OrderSubTotalLabel: string;
  OrderSubTotalTitle: string;
  OrderDiscountLabel: string;
  OrderDiscountTitle: string;
  OrderDeliveryLabel: string;
  OrderDeliveryTitle: string;
  OrderTotalAmountLabel: string;
  OrderTotalAmountTitle: string;
  TaxAmount: number;
  TaxAmountTitle: string;
  OrderStatusLabel: string;
  OrderStatusTitle: string;
  UserAddress: string;
  OrderStatus: number;
  CouponApplied: false;
  CouponId: number;
  CouponCode: string;
  DeliveryCharge: number;
  Discount: number;
  TotalAmount: number;
  OrderNotes: string;
  Products: OrderServices[];
  Services: OrderServices[];
  StoreId: number;
  UserEmail: string;
}
export interface OrderServices {
  ItemName: string;
  ItemPriceTitle: string;
  ExpirationDateTitle: string;
  ItemImage: string;
  Quantity: number;
  ServiceCouponCode: string;
  ExpirationDateLabel: string;
  Type: number;
  Branch: Branch;
  SelectedItemAttributes: ItemAttribute[];
  IsHaveAttributes: boolean;
  ServiceCouponCodeAppliedDateTitle: string;
  ShortDescription: string;
  IsServiceCouponCodeApplied: boolean;
  PriceBundle:PriceBundle | null
}
export interface Branch {
  Id: number;
  Name: string;
  PhoneCode: string;
  PhoneNumber: string;
  Latitude: number;
  Longitude: number;
  Address: string;
  BranchShortDetails:string;
}

export interface CartDeliveryRes extends GoponRes {

}

export interface CartDeliveryList {
  BranchId: number
  BranchName: string
  BranchDeliveryOptions: BranchDeliveryOption[]
}

export interface BranchDeliveryOption {
  BranchDeliveryOptionId: number
  Name: string
  Amount: number
  AmountTitle: string
  ApplyOnRefId: number
}



export interface SelectedBranchDeliveryObj {
  SelectedBranchDelivery: SelectedBranchDelivery[]
}

export interface SelectedBranchDelivery {
  BranchId: number
  BranchDeliveryOptionId: number
}
